/* eslint-disable jsx-a11y/label-has-associated-control */
import classnames from 'classnames';
import {
	Alert, Button, connectedComponent, LoadingIndicator, Modal
} from 'gwx-voyager-components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { loadPreferences, updatePreferences } from './preferences.actions';
import './preferences.scss';

/**
 * Component for Preferences - Opting into ADT types.
 *
 * @class Preferences
 * @extends {Component}
 */
class Preferences extends Component {
	constructor(props) {
		super(props);
		this.handleCheck = this.handleCheck.bind(this);
		this.unsubscribe = this.unsubscribe.bind(this);
		this.onPrefModalClose = this.onPrefModalClose.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.hasAllPrefsUnchecked = this.hasAllPrefsUnchecked.bind(this);
		this.openConfirmation = this.openConfirmation.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
		this.state = {
			buttonsDisabled: false,
			isConfirmationVisible: false,
			errorMsg: null,
			prefs: this.props.preferences[0]
		};
	}

	componentDidMount() {
		const query = {
			communityId: this.props.communityId,
			subscriptionId: this.props.subscriptionId
		};
		this.props.fetchPreferences(query);
	}

	componentDidUpdate(prevProps) {
		if (this.props.preferences[0] !== prevProps.preferences[0]) {
			this.setState({
				prefs: this.props.preferences[0],
				errorMsg: this.props.preferences[0].errorMsg,
				buttonsDisabled: false,
				success: this.props.preferences[0].success
			});
		}
	}

	handleCheck(e) {
		const { target } = e;
		const { prefs } = this.state;
		prefs[target.name] = e.target.checked;
		this.setState({
			prefs
		});
	}

	onValueChange(e){
		const { target } = e;
		const { prefs } = this.state;
		prefs[target.name] = e.target.value==="true"?true:false;
		this.setState({
			prefs
		})
	}

	onModalClose() {
		this.setState({
			isConfirmationVisible: false,
			errorMsg: null
		});
	}

	onPrefModalClose(updatedPreference) {
		if (!updatedPreference) {
			this.props.onPreferencesModalClose();
		} else {
			this.props.preferencesUpdatedModalClose(updatedPreference);
		}
	}

	// eslint-disable-next-line class-methods-use-this
	hasAllPrefsUnchecked(prefs) {
		const allPrefNames = ['a01', 'a03', 'a04e', 'a06', 'a07', 'a11', 'a13', 'a04i', 'a04ob'];
		for (const prefName of allPrefNames) {
			if (prefs[prefName] === true) { return false; }
		}
		return true;
	}

	unsubscribe() {
		this.props.onClickOptOut();
	}

	createConfirmationContent() {
		const confirmationMsg = `Are you sure you want to unsubscribe the provider from the ${this.state.facilityName} Facility?`;

		if (this.state.isConfirmationVisible && this.state.errorMsg) {
			const alertProps = {
				children: this.state.errorMsg,
				type: 'danger',
				visible: true,
				dismissable: false
			};
			var errorAlert = <Alert {...alertProps} />;
		}

		return (
			<div className='text-justify unsubscribe'>
				{errorAlert}
				<p>{confirmationMsg}</p>
			</div>
		);
	}

	handleSubmit() {
		// We want to show unsubscribe alert if all inputs are unchecked exactly as if they had clicked unsubscribe.
		if (this.hasAllPrefsUnchecked(this.state.prefs)) {
			this.openConfirmation(this.state.prefs.sendingFacilityDisplayName);
		} else {
			const body = {
				communityId: this.props.communityId,
				subscriptionId: this.props.subscriptionId,
				a01: this.state.prefs.a01,
				a03: this.state.prefs.a03,
				a04e: this.state.prefs.a04e,
				a06: this.state.prefs.a06,
				a07: this.state.prefs.a07,
				a11: this.state.prefs.a11,
				a13: this.state.prefs.a13,
				a04i: this.state.prefs.a04i,
				a04ob: this.state.prefs.a04ob,
				scheduleNotification: this.state.prefs.scheduleNotification
			};

			this.setState({ buttonsDisabled: true }, () => this.props.savePreferences(body)
				.then((response) => {
					if (response.error) {
						this.setState({
							errorMsg: response.error.message
						});
					} else {
						let updatedPreference;
						// eslint-disable-next-line array-callback-return
						response.response.result.map((r) => {
							updatedPreference = response.response.entities.preferences[r].updatedAdtSubscriptionPreferenceMask;
						});
						this.onPrefModalClose(updatedPreference);
					}
				}));
		}
	}

	openConfirmation(facilityName) {
		this.setState({
			facilityName,
			isConfirmationVisible: true
		});
	}

	render() {
		if (this.props.isFetching || !this.state.prefs) {
			var modalPreferenceContent = (<LoadingIndicator />);
		} else {
			var { prefs } = this.state;

			if (prefs.providerName && prefs.sendingFacilityDisplayName) {
				var providerDetails = (
					<div className='mb-3'>
						<div>
							<b>Name: </b>
							{prefs.providerName}
						</div>
						<div>
							<b>Sending Facility: </b>
							{prefs.sendingFacilityDisplayName}
						</div>
						<div>
							<b>Direct Address: </b>
							{prefs.directAddress}
						</div>
					</div>
				);
			}

			if (!this.state.isConfirmationVisible && this.state.errorMsg) {
				const alertProps = {
					children: this.state.errorMsg,
					type: 'danger',
					visible: true,
					dismissable: false
				};
				var alert = <Alert {...alertProps} />;
			} else if (this.state.resubscribeSuccess) {
				const alertProps = {
					children: 'The provider has been successfully resubscribed.',
					type: 'success',
					visible: true,
					dismissable: false
				};
				alert = <Alert {...alertProps} />;
			}
			const confirmationContent = this.createConfirmationContent();
			const confirmModal = (
				<Modal
					title='Unsubscribe'
					classNames='confirmationModal'
					content={confirmationContent}
					show={this.state.isConfirmationVisible}
					onClose={() => this.onModalClose()}
					closeLabel='Cancel'
					buttons={[
						<Button
							id='unsubscribe-confirm'
							key='unsubscribeConfirm'
							className='btn-success'
							disabled={this.state.buttonsDisabled}
							onClick={() => { this.unsubscribe(); }}
						>
							Confirm
						</Button>]}
				/>
			);
			const content = (
				<div>
					{providerDetails}
					<div className='mb-2'>
						<b>ADT Types</b>
					</div>
					<div className='mb-3 adt-types'>
						<label className='d-block' htmlFor='a01'>
							<input
								className='mr-3'
								name='a01'
								type='checkbox'
								value='Admit (A01)'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a01}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Admit (A01)</span>
						</label>
						<label className='d-block' htmlFor='a11'>
							<input
								className='mr-3'
								name='a11'
								type='checkbox'
								value='Cancel Admit (A11)'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a11}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Cancel Admit (A11)</span>
						</label>
						<label className='d-block' htmlFor='a03'>
							<input
								className='mr-3'
								name='a03'
								type='checkbox'
								value='Discharge (A03)'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a03}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Discharge (A03)</span>
						</label>
						<label className='d-block' htmlFor='a13'>
							<input
								className='mr-3'
								name='a13'
								type='checkbox'
								value='Cancel Discharge (A13)'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a13}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Cancel Discharge (A13)</span>
						</label>
						<span className='registration-desc d-block'>Registration (A04)</span>
						<label className='registration-desc d-block' htmlFor='a04e'>
							<input
								className='mr-3'
								name='a04e'
								type='checkbox'
								value='Emergency'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a04e}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Emergency</span>
						</label>
						<label className='registration-desc d-block' htmlFor='a04ob'>
							<input
								className='mr-3'
								name='a04ob'
								type='checkbox'
								value='Observation'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a04ob}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Observation</span>
						</label>
						<label className='registration-desc d-block' htmlFor='a04i'>
							<input
								className='mr-3'
								name='a04i'
								type='checkbox'
								value='Inpatient'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a04i}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Inpatient</span>
						</label>
						<label className='d-block' htmlFor='a06'>
							<input
								className='mr-3'
								name='a06'
								type='checkbox'
								value='Outpatient to Inpatient (A06)'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a06}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Outpatient to Inpatient (A06)</span>
						</label>
						<label className='d-block' htmlFor='a07'>
							<input
								className='mr-3'
								name='a07'
								type='checkbox'
								value='Inpatient to Outpatient (A07)'
								onChange={(e) => this.handleCheck(e)}
								checked={prefs.a07}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Inpatient to Outpatient (A07)</span>
						</label>	
					</div>
					<div className="mb-2">
						<b>Notification Delivery</b>
					</div>
					<div className ='schedule-notification-desc'>
						<label className ='d-block' htmlFor='scheduleAdt'>
							<input
								className='mr-3'
								name='scheduleNotification'
								type='radio'
								value= {false}
								onChange={(e)=>this.onValueChange(e)}
								checked={!prefs.scheduleNotification}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Real-Time</span>
						</label>
						<label className='d-block' htmlFor='scheduleAdt'>
							<input
								className='mr-3'
								name='scheduleNotification'
								type='radio'
								value= {true}
								onChange={(e)=>this.onValueChange(e)}
								checked={prefs.scheduleNotification}
								disabled={prefs.isUnsubscribed}
							/>
							<span>Nightly Batch</span>
						</label>
					</div>
				</div>
			);

			modalPreferenceContent = (
				<div className='preferences'>
					<div className={classnames({ container: !this.state.linkedFromUnsubscribe })}>
						{alert}
						{content}
						{confirmModal}
					</div>
				</div>
			);
		}

		return (
			<Modal
				title='Preferences'
				content={modalPreferenceContent}
				show
				classNames='preferencesModal'
				onClose={() => this.onPrefModalClose(null)}
				closeLabel='Cancel'
				buttons={[
					<Button
						id='save-prefs'
						key='savePrefs'
						className='btn-success'
						disabled={(prefs && prefs.isUnsubscribed) || this.state.buttonsDisabled}
						onClick={() => this.handleSubmit()}
					>
						Save
					</Button>]}
			/>
		);
	}
}

Preferences.propTypes = {
	communityId: PropTypes.string,
	subscriptionId: PropTypes.string,
	sendingFacilityDisplayName: PropTypes.string,
	fetchPreferences: PropTypes.func.isRequired,
	savePreferences: PropTypes.func.isRequired,
	onClickOptOut: PropTypes.func.isRequired,
	onPreferencesModalClose: PropTypes.func.isRequired
};

/**
 * Maps the redux store's state to a set of props to be
 * passed to the Preferences component.
 *
 * @param {object} state
 * 		The current state of the redux store.
 */
const mapStateToProps = (state, props) => {
	const {
		entities: { preferences }
	} = state;

	return {
		isFetching: preferences.isFetching,
		preferences: preferences.ids.map((id) => preferences.results[id]),
		component: 'preferences'
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchPreferences: (query) => { dispatch(loadPreferences(query)); },
	savePreferences: (body) => (dispatch(updatePreferences(body))
		.then((response) => {
			if (response.error) {
				return response.error;
			}
			dispatch({
				type: 'TRIGGER_ALERT',
				alert: {
					type: 'success',
					dismissable: true,
					message: 'The provider\'s preferences have successfully been updated.',
					duration: 5000
				}
			});
			return response;
		}))
});

const PreferencesContainer = connectedComponent(Preferences, mapStateToProps, mapDispatchToProps);

export { PreferencesContainer as default, Preferences };
